import { HttpClient } from 'api/http-client';
class RlMarketplaceHTTPClient extends HttpClient {
    async getInstallationsInAccount() {
        return this.get('/marketplace/installations');
    }
    async getInstalledMarketplaceApps() {
        return this.get('/marketplace/apps/installed');
    }
    async getInstallationDetails(appId) {
        return this.get(`/marketplace/app/${appId}/installation`);
    }
    // /apps/{appId}/version/{versionId}/widgets
    async getWidgets(appId, versionId) {
        return this.get(`/marketplace/apps/${appId}/version/${versionId}/widgets`);
    }
    async getServerActions(appId, versionId) {
        return this.get(`/marketplace/apps/${appId}/version/${versionId}/server-actions`);
    }
    async runServerAction(appId, serverActionName, payload, params) {
        return this.post(`/marketplace/apps/${appId}/server-actions/${serverActionName}/run`, {
            payload
        }, {
            params
        });
    }
    async getInvokeServerActionResponse(appId, requestId) {
        return this.get(`/marketplace/apps/${appId}/server-actions/response/${requestId}`);
    }
    // /apps/installed-widgets
    async getInstalledWidgets() {
        return this.get('/marketplace/apps/installed-widgets');
    }
    async getWidgetById(appId, versionId, widgetId) {
        return this.get(`/marketplace/apps/${appId}/version/${versionId}/widgets/${widgetId}`);
    }
    async enableAppInstallation(appId) {
        return this.post(`/marketplace/apps/${appId}/installations/enable`, {});
    }
    async disableAppInstallation(appId) {
        return this.post(`/marketplace/apps/${appId}/installations/disable`, {});
    }
    async formatWidgetFields(payload) {
        return this.post('/marketplace/fields/format', payload);
    }
    async deleteAppInstallation(appId) {
        return this.delete(`/marketplace/apps/${appId}/installation/`);
    }
}
export const RlMarketplaceApi = new RlMarketplaceHTTPClient();
